import { LS_KEYS } from "../constants"
import z, { ZodType } from "zod"

export function readLocalStorage<T extends z.ZodTypeAny>(args: {
  key: keyof typeof LS_KEYS | string;
  schema: T;
}): z.infer<T> | undefined;

export function readLocalStorage<T extends z.ZodTypeAny>(args: {
  key: keyof typeof LS_KEYS | string;
  schema: T;
  d: z.infer<T>;
}): z.infer<T>;

export function readLocalStorage<T extends z.ZodTypeAny>({
  key,
  schema,
  d,
}: {
  key: keyof typeof LS_KEYS | string;
  schema: T;
  d?: z.infer<T>;
}): z.infer<T> | undefined {
  const content = localStorage.getItem(`${LS_KEYS.version}#${key}`);
  const c = content ? JSON.parse(content) : d;
  const {success, data, error} = schema.safeParse(c);
  if(data && success) {
    return data;
  }else {
    console.trace("Failed to parse", c, error);
    return d;
  }
}

export const writeLocalStorage = <T extends ZodType>({key, schema, value}: {
    key: keyof typeof LS_KEYS | string, 
    schema: T, 
    value: z.infer<T>
}): void => {
    try {
      localStorage.setItem(`${LS_KEYS.version}#${key}`, JSON.stringify(schema.parse(value)));
    }catch(e) {
      console.error("Error writing local storage", e);
      throw e;
    }
}